import { z } from 'zod';

export const phoneRegex = /^\+?[1-9]\d{1,14}$/;
export const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

export const contactSchema = z.object({
  id: z.string().optional(),
  firstName: z.string().min(1, 'First name is required'),
  middleName: z.string().optional(),
  lastName: z.string().min(1, 'Last name is required'),
  relationship: z.enum(['parent_guardian', 'emergency_contact', 'other']),
  primaryPhone: z.string().regex(phoneRegex, 'Invalid phone number'),
  email: z.string().regex(emailRegex, 'Invalid email address'),
  priority: z.enum(['primary', 'secondary', 'emergency']),
  isPrimary: z.boolean().optional(),
  secondaryPhone: z.string().regex(phoneRegex, 'Invalid phone number').optional(),
  address: z.string().optional(),
  preferredContact: z.enum(['phone', 'email', 'text']).optional(),
  language: z.string().optional(),
  occupation: z.string().optional(),
  availableHours: z.string().optional(),
  notes: z.string().optional()
});

export type ContactFormData = z.infer<typeof contactSchema>;

export const INITIAL_FORM_DATA: ContactFormData = {
  firstName: '',
  middleName: '',
  lastName: '',
  relationship: 'parent_guardian',
  primaryPhone: '',
  email: '',
  priority: 'primary',
  isPrimary: false,
  secondaryPhone: '',
  address: '',
  preferredContact: 'phone',
  language: '',
  occupation: '',
  availableHours: '',
  notes: ''
};